import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  totalRequests = 0;
  private readonly _isLoading$: BehaviorSubject<boolean>;
  readonly isLoading$: Observable<boolean>;

  private readonly _isDisabled$: BehaviorSubject<boolean>;
  readonly isDisabled$: Observable<boolean>;

  protected constructor() {
    this._isLoading$ = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this._isLoading$.asObservable();

    this._isDisabled$ = new BehaviorSubject<boolean>(false);
    this.isDisabled$ = this._isDisabled$.asObservable();
  }

  setLoading(isLoading = true): void {
    this._isLoading$.next(isLoading);
  }

  setDisbled(isDisabled = true): void {
    this._isDisabled$.next(isDisabled);
  }
}
